import React from 'react'
import SubMenuWrapper from './SubMenuWrapper'
import MenuItem from '../MenuItem'

const isUserSchoolOrStudent = userType => userType === 'STUDENT' || userType === 'SCHOOL'

const EventsItems = ({isSidebarOpen, userType}) => {
  const myEventsUrl = '/dashboard/events' + (isUserSchoolOrStudent(userType)? '/my-events' : '')

  return <SubMenuWrapper
    label='رویدادها'
    iconClass='fa fa-calendar'
    isSideBarOpen={isSidebarOpen}
    className="vertical-menu"
    >

    <MenuItem
      label='همه رویدادها'
      iconClass='fa fa-list'
      url='/v/list/?type=exam'
      isExternal={true}
      />

    <MenuItem
      label='رویدادهای من'
      iconClass='fa fa-bookmark-o'
      url={myEventsUrl}
      />

  </SubMenuWrapper>
}

export default EventsItems


// WEBPACK FOOTER //
// ./src/components/common/SidebarMenu/EventsItems.js